<template>
  <div class='reportList'>
    <el-row class="reportList-nav" id="reportListnav">
      <el-col :class="{'toggleSearchType':isActive}">
        <el-form :inline="true" :model="search" ref="search" size="mini" class="demo-form-inline">
          <el-row class="nav-top">
            <el-form-item label prop="patientName">
              <el-input v-model="search.patientName" placeholder="患者姓名"></el-input>
            </el-form-item>
            <el-form-item label prop="patientNo">
              <el-input v-model="search.patientNo" placeholder="影像号"></el-input>
            </el-form-item>
            <el-form-item label prop="RegNo">
              <el-input v-model="search.RegNo" placeholder="登记单号"></el-input>
            </el-form-item>
            <el-form-item label prop="SrcHospitalName">
              <el-input v-model="search.SrcHospitalName" placeholder="检查医院"></el-input>
            </el-form-item>
            <el-form-item label prop="PatientType">
              <el-select v-model="search.PatientType" placeholder="患者来源">
                <el-option
                  v-for="item in dict.patientSource"
                  :key="item.id"
                  :label="item.dictName"
                  :value="item.dictName"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="" prop="SubmitterName">
              <el-input v-model="search.SubmitterName" placeholder="诊断医生"></el-input>
            </el-form-item>-->
            <el-form-item style="width:7%;min-width: 60px;">
              <el-button
                style="width:100%;"
                type="primary"
                icon="el-icon-search"
                @click="onSubmit(1)"
              >查询</el-button>
            </el-form-item>
            <el-form-item style="width:7%;min-width: 60px;">
              <el-button
                style="width:100%;"
                type="success"
                icon="el-icon-circle-close-outline"
                @click="resetForm"
              >清空</el-button>
            </el-form-item>
            <!-- <el-form-item  style="width:7%;min-width: 60px;">
              <el-button  @click="Excel" size='mini' style="width:100%;"
                type="primary">导出Excel</el-button>
            </el-form-item> -->
            <el-form-item style="float:right;margin-bottom:0px;margin-right:0px;width:5%;">
              <el-button
                style="font-size:18px;width:50px;color: #3A4A64;font-size: 21px;"
                type="text"
                @click="toggleClick"
              >
                <i :class="{'is-active':isActive}" class="hamburger el-icon-arrow-down"></i>
              </el-button>
            </el-form-item>

          </el-row>
          <div class="toggleSearch">
            <el-row>
              <el-col>
                <el-form-item label="检查时间">
                  <el-radio-group v-model="timeType">
                    <el-radio-button
                      v-for="item in getTime"
                      :key="item.Value"
                      :label="item.Value"
                    >{{item.Text}}</el-radio-button>
                    <el-radio-button label="4" class="nav-time">
                      <el-date-picker
                        v-model="search.DateArray"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="changeTime"
                      ></el-date-picker>
                    </el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="设备类型">
                  <el-radio-group v-model="search.Modality" @change="onSubmit(1)">
                    <el-radio-button label>全部</el-radio-button>
                    <el-radio-button
                      v-for="item in checkList.checkType"
                      :key="item.name"
                      :label="item.name"
                    >{{item.name}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="检查部位">
                  <el-radio-group v-model="search.bodyPart" @change="onSubmit(1)">
                    <el-radio-button label>全部</el-radio-button>
                    <el-radio-button
                      v-for="item in checkList.checkBody"
                      :key="item.name"
                      :label="item.name"
                    >{{item.name}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <div class="reportList-table">
      <el-table
        v-if="writeReportList.length > 0"
        :row-class-name="tableRowClassName"
        stripe
        :data="writeReportList"
        size="mini"
        v-loading="tableloading"
        style="width: 100%"
        @row-dblclick="dbTalble"
      >
        <el-table-column :fixed="index === 0" v-if="col.isShow" v-for="(col, index) in headerList"
          :key="index"
          :min-width="col.width"
          :prop="col.prop"
          :label="col.label"
          :show-overflow-tooltip = 'true'

        >
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" v-if="col.prop === 'checkingItems'">
              {{ scope.row[col.prop] | checkingItems}}
              <div slot="reference" class="name-wrapper">
                <span style="background: #ff9d60;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop] | checkingItems}}</span>
                <div v-else></div>
              </div>
            </el-popover>
            <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'modalityName'">
              {{ scope.row[col.prop]}}
              <div slot="reference" class="name-wrapper">
                <span style="background: #FF8C8C;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                <div v-else></div>
              </div>
            </el-popover>
            <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'bodyParts'">
              {{ scope.row[col.prop]}}
              <div slot="reference" class="name-wrapper">
                <span style="background: #49C1E4;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                <div v-else></div>
              </div>
            </el-popover>
            <span v-else>
              {{scope.row[col.prop]}}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop='patientName' align='center' label='姓名' width='100px'>
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top" v-if='scope.row.sendType!==0'>
                    <span style="text-align:center;" v-if='scope.row.sendType===2'>收到{{scope.row.col.prop}}的远程请求</span>
                    <span style="text-align:center;" v-if='scope.row.sendType===1'>发往{{scope.row.destHospitalName}}的远程请求</span>
                  <div slot="reference" class="">
                    <div style="text-align:center;">{{ scope.row.patientName }} <svg-icon v-if='scope.row.sendType===2' icon-class='from-outside'></svg-icon><svg-icon v-if='scope.row.sendType===1' icon-class='to-outside'></svg-icon></div>
                    <span v-if='scope.row.regIsEmergency' style="width: 29px;position: absolute;left: 0;top: 0;display:inline-block;"><img style="width:100%;" src="../../assets/Emergency.png" alt=""></span>
                  </div>
                </el-popover>
                <div v-else>
                  <div style="text-align:center;">{{ scope.row.patientName }} <svg-icon v-if='scope.row.sendType===2' icon-class='from-outside'></svg-icon><svg-icon v-if='scope.row.sendType===1' icon-class='to-outside'></svg-icon></div>
                  <span v-if='scope.row.regIsEmergency' style="width: 29px;position: absolute;left: 0;top: 0;display:inline-block;"><img style="width:100%;" src="../../assets/Emergency.png" alt=""></span>
                </div>

               </template>
            </el-table-column>
            <el-table-column prop='sexName' label='性别' width='100px'> </el-table-column>
            <el-table-column prop='age' label='年龄' width='100px'> </el-table-column>
            <el-table-column prop='statusName' label='医疗状态' width='110px'></el-table-column>
            <el-table-column prop='patientNo' label='影像号' width='180px'> </el-table-column>
            <el-table-column prop='patientType' label='患者来源' width='110px'> </el-table-column>
            <el-table-column prop='regNo' label='登记单号' width='180px'> </el-table-column>
            <el-table-column prop='register' label='登记医生' width='110px'> </el-table-column>
        <el-table-column prop='regDt' label='登记时间' min-width="180px"> </el-table-column>-->
        <!-- <el-table-column prop='printedCount' label='是否打印' min-width="180px"> </el-table-column> -->
        <el-table-column prop label="功能" min-width="190px" size="mini" fixed="right">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="影像诊断" placement="top">
              <el-button
                style="background:#44cc79;color:#fff;border:none;float:left;margin-right:10px;"
                type
                size="mini"
                circle
                @click="dbTalble(scope.row)"
              >
                <svg-icon icon-class="writereport"></svg-icon>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="查看影像" placement="top">
              <el-button
                style="background:#5AB1EF;color:#fff;border:none;float:left;margin-right:10px;"
                type
                size="mini"
                circle
                @click="pacsImg(scope.row.webPacsUrl)"
              >
                <svg-icon icon-class="preview_1"></svg-icon>
              </el-button>
            </el-tooltip>
            <template v-if="scope.row.sendType !== 2">
              <el-tooltip class="item" effect="dark" content="远程会诊" placement="top" v-if="scope.row.statusName === '待诊断' ">
                <el-button
                  style="background:#8470F2;color:#fff;border:none;float:left;margin-right:10px;"
                  type
                  size="mini"
                  circle
                  @click="GetDiagnosticDeparts(scope.row)"
                >
                  <svg-icon icon-class="consultation"></svg-icon>
                </el-button>
              </el-tooltip>
            </template>
            <template  v-if="scope.row.sendType === 2">
              <el-tooltip class="item" effect="dark" content="报告退回" placement="top" v-if="scope.row.statusName === '待诊断' ">
                <el-button style="background:#FF6E6E;color:#fff;border:none;" type="" size='mini' @click="RollBackAllocation(scope.row)" circle><svg-icon  icon-class='reason'></svg-icon></el-button>
              </el-tooltip>
            </template>
            <template v-if="scope.row.sendType !== 2">
              <el-tooltip
                class="item"
                effect="dark"
                content="患者登记修改"
                placement="top"
                v-if="scope.row.statusName === '待诊断' "
              >
                <el-button
                  style="background:#FFB22D;color:#fff;border:none;"
                  type
                  size="mini"
                  circle
                  @click="editRegistration(scope.row)"
                >
                  <svg-icon icon-class="患者登记修改" class="svg2"></svg-icon>
                </el-button>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div v-else style="width:100%;text-align:center;background:#f8f8f8;">
        <img src="../../assets/empty_01.png" alt style="height: calc(100vh - 353px);width: auto;">
      </div>
    </div>
    <el-row style="text-align: center;" v-if="writeReportList.length > 0">
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80, 100]"
          :page-size="search.PageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="ReportListtotalCount"
        ></el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="远程会诊"
      :visible.sync="dialogTableVisible"
      width="700px"
      custom-class="revisitDialog"
      ref="dialog"
      @close="close"
    >
      <el-row style="margin-top:20px;border-top:1px solid #397EE3;">
        <el-table
          :data="DiaDeparts"
          stripe
          max-height="300px"
          size="mini"
          height="250"
          v-loading="hospListloading"
          highlight-current-row @current-change="handleCurrentChanges"
        >
          <el-table-column property="hospName" label="医院名称"></el-table-column>
          <el-table-column property="departName" label="科室名称"></el-table-column>
        </el-table>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini' style="" @click="consultation(fillInfors)"> 确 定 </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="退回原因"
      :visible.sync="dialogTableVisibles"
      width="700px"
      custom-class="revisitDialog"
      ref="dialog"
      @close="close"
    >
      <el-row style="margin-top:20px;">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 10}"
          placeholder="请填写退回原因"
          v-model="RollBackAllocations.note">
        </el-input>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SubmitReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
import common from '@/utils/common.js'
export default {
  name: 'reportList',
  data() {
    return {
      tableloading: false,
      dialogTableVisible: false,
      dialogTableVisibles: false,
      hospListloading: false,
      search: {
        Status: 0,
        patientName: '',
        patientNo: '',
        RegNo: '',
        PerformId: '',
        PatientType: '',
        SubmitterName: '',
        DateArray: [new Date(), new Date()],
        Modality: '',
        bodyPart: '',
        DepartId: '',
        PageIndex: 1,
        PageCount: 10,
        CompleteStatus: 0,
        IsShowAll: 1,
        SendTypes: [1, 2],
        SrcHospitalName: ''
      },
      consultations: {
        procedureIds: [],
        departId: '',
        hospId: '',
        destHospId: '',
        destDepartId: '',
        note: ''
      },
      RollBackAllocations: {
        procedureIds: [],
        departId: '',
        hospId: '',
        note: ''
      },
      getTime: common.SettingsTime.value,
      getqueryType: common.SettingsqueryType.value,
      ReportList: [],
      timeType: 0,
      isActive: false,
      navHeight: 102,
      activeName2: 'allList',
      currentPage: 1
    }
  },
  beforeMount() {
  },
  mounted() {

  },
  created() {
    this.search.DateArray = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
    this.handleClick(this.activeName2)
    this.getChecktype()
    this.getPdfPrintTemplateList()
    this.GetTableHeaderConfigs()
  },
  computed: {
    ...mapGetters([
      'writeReportList',
      'dict',
      'userId',
      'ReportVariable',
      'lock',
      'ReportListtotalCount',
      'checkList',
      'currentUserRoleDepart',
      'printList',
      'headerList',
      'DiaDeparts'
    ]),
    newModality() {
      return this.search.Modality
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.isShowWarningTime === 1) {
        return 'warning-row'
      }
      return ''
    },
    handleSizeChange(val) {
      this.search.PageCount = val
      this.onSubmit(1)
    },
    handleCurrentChange(val) {
      this.onSubmit(val)
    },
    toggleClick: function() {
      this.isActive = !this.isActive
    },
    checkTimeType(type) {
      if (type === 0) {
        this.search.DateArray = [new Date(), new Date()]
      }
      if (type === 1) {
        this.search.DateArray = [new Date(new Date() - 3600 * 1000 * 24), new Date()]
      }
      if (type === 2) {
        this.search.DateArray = [new Date(new Date() - 3600 * 1000 * 24 * 3), new Date()]
      }
      if (type === 3) {
        this.search.DateArray = [new Date(new Date() - 3600 * 1000 * 24 * 7), new Date()]
      }
      if (type === 4) {
        this.search.DateArray = this.search.DateArray
      }
      this.onSubmit(1)
    },
    getBody(value) {
      if (value) {
        var temp = ''
        for (let i = 0; i < this.checkList.checkType.length; i++) {
          if (this.checkList.checkType[i].name === value) {
            temp = this.checkList.checkType[i].modality
            break
          }
        }
        this.$store.dispatch('getcheckBody', { departId: this.currentUserRoleDepart.departId, modality: temp }).then(() => { // 提交登记
        }).catch(() => {
          this.$message({ message: '获取检查部位失败，请重新获取', type: 'warning' })
        })
      }
    },
    getChecktype() {
      this.$store.dispatch('getcheckType', { departId: this.currentUserRoleDepart.departId }).then(() => { // 提交登记

      }).catch(() => {
        this.$message({ message: '获取设备类型失败，请重新获取', type: 'warning' })
      })
    },
    GetTableHeaderConfigs() {
      this.$store.dispatch('GetTableHeaderConfigs', { departId: this.currentUserRoleDepart.departId, type: 5 }).then(() => { // 提交登记
      }).catch(() => {
        this.$message({ message: '获取表头配置失败，请重新获取', type: 'warning' })
      })
    },
    handleClick(datas) {
      if (datas === 'allList') {
        this.search.CompleteStatus = 0
      }
      if (datas === 'waitList') {
        this.search.CompleteStatus = 5
      }
      if (datas === 'startList') {
        this.search.CompleteStatus = 10
      }
      if (datas === 'endList') {
        this.search.CompleteStatus = 20
      }
      this.onSubmit(1)
    },
    onSubmit(val) {
      this.search.PageIndex = val
      this.table = true
      this.tableloading = true
      this.$store
        .dispatch('GetReportList', this.search)
        .then(() => {
          this.loading = false
          this.tableloading = false
        })
        .catch(() => {
          this.loading = false
          this.tableloading = false
        })
    },
    resetForm() {
      this.$refs['search'].resetFields()
      this.search.Modality = ''
      this.search.bodyPart = ''
    },
    dbTalble: function(row) {
      this.$store
        .dispatch('getLock', { procedureId: row.procedureId, departId: this.currentUserRoleDepart.departId })
        .then(() => {
          if (this.lock.data) {
            if (row.status === 50) {
              sessionStorage.setItem('setReportVariable', JSON.stringify({ procedureId: row.procedureId, type: '1' })) // 添加到sessionStorage
              this.$store.dispatch('getReportVariable').then(() => {})
              this.$router.push({ path: '/writereport', query: { isconsultation: true }})
              this.pacsImg(row.webPacsUrl)
              this.$message({ message: '操作成功', type: 'success' })
            }
            if (row.status === 60) {
              sessionStorage.setItem('setReportVariable', JSON.stringify({ procedureId: row.procedureId, type: '1' })) // 添加到sessionStorage
              this.$store.dispatch('getReportVariable').then(() => {})
              this.$router.push({ path: '/writereport', query: { isconsultation: true }})
              this.pacsImg(row.webPacsUrl)
              this.$message({ message: '操作成功', type: 'success' })
            }
            if (row.status > 60) {
              sessionStorage.setItem('setReportVariable', JSON.stringify({ procedureId: row.procedureId, type: '1' })) // 添加到sessionStorage
              this.$store.dispatch('getReportVariable').then(() => {})
              this.$router.push({ path: '/writereport', query: { isconsultation: true }})
              this.pacsImg(row.webPacsUrl)
              this.$message({ message: '操作成功', type: 'success' })
            }
          } else {
            this.$message({ message: this.lock.message, type: 'success' })
          }
        }).catch(() => {
          this.$message({ message: this.lock.message, type: 'success' })
        })
    },
    changeTime: function() {
      this.timeType = 4
    },
    pacsImg: function(url) {
      window.open(url, 'pacsImg', 'top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes')
    },
    editRegistration(data) {
      this.$router.push({ path: '/editConsultation', name: 'EditConsultation', query: { regId: data.regId, consultation: true }})
    },
    getPdfPrintTemplateList() {
      this.$store.dispatch('getPdfPrintTemplateList').then(() => { // 模板列表
        if (this.printList.length > 0) {
          this.reportModule = this.printList[0].templateId
        }
      }).catch(() => {
        this.$message({ message: '获取模板列表失败!', type: 'error' })
      })
    },
    printReport(datas) {
      var patientNo = ''
      if (this.reportModule) {
        window.open(this.$getCfg('VUE_APP_BASE_API') + '/common/getreportpdf?reportId=' + datas.reportId + '&templateId=' + this.reportModule + '&fileName=' + patientNo, '_blank')
      } else {
        this.$message({ message: '请选择打印模板!', type: 'error' })
      }
    },
    handleCurrentChanges(val) {
      this.fillInfors = val
    },
    SubmitReturn() {
      this.$store
        .dispatch('RollBackAllocation', this.RollBackAllocations)
        .then(() => {
          this.onSubmit(1)
          // 退回
        })
        .catch(() => {
        })
      this.dialogTableVisibles = false
    },
    close() {
      this.ConHospList = []
    }
  },
  watch: {
    $route() {
      this.$store.dispatch('resetdiagnostic')
    },
    newModality(val) {
      this.search.bodyPart = ''
      this.getBody(this.search.Modality)
    },
    timeType(type) {
      this.checkTimeType(type)
    }
  },
  filters: {
    checkingItems(datas) {
      if (datas) {
        if (datas.length > 11) {
          datas = datas.slice(0, 10) + '…'
        }
        return datas
      } else {
        return ''
      }
    }
  }

}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
  .reportList{
    height: 100%;
    overflow-y: auto;
    .el-tabs{
      padding: 0px 20px;
      margin-top: 20px;
    }
    .reportList-nav{
      height: auto;
      background: #f8f8f8;
      margin:0px 20px 20px 20px;
      padding: 10px;
      .el-form-item{
        margin-bottom: 10px;
      }
      // .el-checkbox-button, .el-checkbox-button__inner{
      //   margin-right: 10px;
      // }

    }
    .reportList-table{
      border-top: 2px solid #ddd;
      background: #f3f5f9;
      margin:20px;
    }
    .hamburger {
      transform: rotate(0deg);
      transition: .38s;
      transform-origin: 50% 50%;
    }
    .hamburger.is-active {
      transform: rotate(180deg);
    }
    .toggleSearch{
      height: 0px;
      -webkit-transition: height .28s;
      transition: height .28s;
      overflow: hidden;
    }
    .toggleSearchType .toggleSearch{
      height: 150px;
      -webkit-transition: height .28s;
      transition: height .28s;
      overflow: hidden;
    }
    .name-wrapper{
      height: 23px;
      span{
        background: #FF9D60;
        color:#fff;
        padding: 4px 5px;
        border-radius: 3px;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .nav-top{
      .el-form-item{
        width: 12.5%;
      }
    }
  }
</style>
